require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-is-this-australias-best-health-and-wellness-centre.json") })
        }
      }, "path---news-is-this-australias-best-health-and-wellness-centre");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-is-this-australias-best-health-and-wellness-centre!./.cache/json/news-is-this-australias-best-health-and-wellness-centre.json
// module id = 824
// module chunks = 231608221292675